import { environment } from '../../../../../environments/environment';
import { AppConstants } from '../services/api/app-constants';

//listCpVehicleMasters  po_number document_code rental_month
/*****************************************************************************
 * VEHICLE MASTER
 * $car_id: String,$status:String
 * ($limit: Int!,$nextToken:String)
 * document_code
          rental_month
          po_number
 ****************************************************************************/
export const getVehicleMasterQueries = {
  query: `
  query getVehicleMaster ($nextToken: String, $limit: Int){
    ${AppConstants.list}${environment.dbPrefix}${AppConstants.listCpVehicleMaster}(nextToken: $nextToken, limit: $limit)
    {
      items {
        id
          car_model
          veh_reg_id
          policy_no
          policy_from
          policy_to
          agency_name
          agency {
            id
            name
          }
          map_user_id
          lease_from
          lease_to
          car_type
          ex_data
          car_make
          car_variant
          car_color
          fuel_type
          car_registration_date
          chasis_number
          asset_number
          surrender_date
          created_date
          updated_date
          vehicle_rc_book_attachments
          {
            uploaded_on
            url
          }
          insurance_policy_attachments
          {
            uploaded_on
            url
          }
          vehicle_lease_attachments
           {
            uploaded_on
            url
          }
          surrender_car_attachments
          {
            uploaded_on
            url
          }
      }
      nextToken
    }


  }
  `,
};
// document_code
// rental_month
// po_number
// document_code
// rental_month
// po_number
/*****************************************************************************
 * FILTER VEHICLE MAINTENANCE
 ****************************************************************************/

export const filterByVehicleIDQueries = {
  query: `
  query filterVehicleMaster($id: ID!){
    ${AppConstants.list}${environment.dbPrefix}${AppConstants.listCpVehicleMaster} (filter:{
      id : { eq : $id}
    })
    {
      items {
        id
          car_model
          veh_reg_id
          policy_no
          policy_from
          policy_to
          agency_name
          map_user_id
          lease_from
          lease_to
          car_type
          ex_data
          car_make
          car_variant
          car_color
          fuel_type
          car_registration_date
          chasis_number

          asset_number
          surrender_date
          created_date
          updated_date
          vehicle_rc_book_attachments
          {
            uploaded_on
            url
          }
          insurance_policy_attachments
          {
            uploaded_on
            url
          }
          vehicle_lease_attachments
           {
            uploaded_on
            url
          }
          surrender_car_attachments
          {
            uploaded_on
            url
          }
      }
      nextToken
    }


  }
  `,
};
// document_code
// rental_month
// po_number
export const filterByVehicleStatusQueries = {
  query: `
  query filterVehicleMaster($ex_data: String){
    ${AppConstants.list}${environment.dbPrefix}${AppConstants.listCpVehicleMaster} (filter:{
      ex_data : { eq : $ex_data}
    })
    {
      items {
        id
          car_model
          veh_reg_id
          policy_no
          policy_from
          policy_to
          agency_name
          map_user_id
          lease_from
          lease_to
          car_type
          ex_data
          car_make
          car_variant
          car_color
          fuel_type
          car_registration_date
          chasis_number

          asset_number
          surrender_date
          created_date
          updated_date
          vehicle_rc_book_attachments
          {
            uploaded_on
            url
          }
          insurance_policy_attachments
          {
            uploaded_on
            url
          }
          vehicle_lease_attachments
           {
            uploaded_on
            url
          }
          surrender_car_attachments
          {
            uploaded_on
            url
          }
      }
      nextToken
    }


  }
  `,
};

export const createVehicleMasterQueries = {
  mutation: `
    mutation createVehicle(
      $car_model: String,
      $veh_reg_id: String,
      $policy_no: String,
      $policy_from: String,
      $policy_to: String,
      $agency_name: String,
      $lease_from: String,
      $lease_to: String,
      $car_type: String,
      $ex_data: String,
      $car_make: String,
      $car_variant: String,
      $car_color: String,
      $fuel_type: String,
      $car_registration_date: String,
      $chasis_number: String,
      $map_user_id:String,
      $asset_number: String,
      $surrender_date: String,
      $document_code: String,
      $rental_month: String,
      $po_number: String,
      $vehicle_rc_book_attachments: [FileUploadInput],
      $insurance_policy_attachments: [FileUploadInput],
      $vehicle_lease_attachments: [FileUploadInput],
      $surrender_car_attachments:[FileUploadInput],
      $created_date: String,
      $updated_date: String
    ) {
      ${AppConstants.create}${environment.dbPrefix}${AppConstants.createCpVehicleMaster}(input: {
        car_model: $car_model,
        veh_reg_id: $veh_reg_id,
        policy_no: $policy_no,
        policy_from: $policy_from,
        policy_to: $policy_to,
        agency_name: $agency_name,
        lease_from: $lease_from,
        lease_to: $lease_to,
        car_type: $car_type,
        ex_data: $ex_data,
        car_make: $car_make,
        car_variant: $car_variant,
        car_color: $car_color,
        fuel_type: $fuel_type,
        car_registration_date: $car_registration_date,
        chasis_number: $chasis_number,
        map_user_id:$map_user_id,
        asset_number: $asset_number,
        surrender_date: $surrender_date,
        document_code: $document_code,
        rental_month: $rental_month,
        po_number: $po_number,
        vehicle_rc_book_attachments: $vehicle_rc_book_attachments,
        insurance_policy_attachments: $insurance_policy_attachments,
        vehicle_lease_attachments: $vehicle_lease_attachments,
        surrender_car_attachments:$surrender_car_attachments,
        created_date: $created_date,
        updated_date: $updated_date
      }) {

          id
          car_model
          veh_reg_id
          policy_no
          policy_from
          policy_to
          agency_name
          map_user_id
          lease_from
          lease_to
          car_type
          ex_data
          car_make
          car_variant
          car_color
          fuel_type
          car_registration_date
          chasis_number
          asset_number
          surrender_date
          document_code
          rental_month
          po_number
          created_date
          updated_date
          vehicle_rc_book_attachments
          {
            uploaded_on
            url
          }
          insurance_policy_attachments
          {
            uploaded_on
            url
          }
          vehicle_lease_attachments
           {
            uploaded_on
            url
          }
          surrender_car_attachments
          {
            uploaded_on
            url
          }
      }
    }
  `,
};
// $surrender_date: String,
//       $document_code: String,
//       $rental_month: String,
// document_code: $document_code,
//         rental_month: $rental_month,
//         po_number: $po_number,
// document_code
//           rental_month
//           po_number
export const updateVehicleMasterQueries = {
  mutation: `
    mutation updateVehicle(
      $id: ID!,
      $car_model: String,
      $veh_reg_id: String,
      $policy_no: String,
      $policy_from: String,
      $policy_to: String,
      $agency_name: String,
      $lease_from: String,
      $lease_to: String,
      $car_type: String,
      $ex_data: String,
      $car_make: String,
      $car_variant: String,
      $car_color: String,
      $fuel_type: String,
      $car_registration_date: String,
      $chasis_number: String,
      $map_user_id:String,
      $asset_number: String,
      $surrender_date: String,
      $document_code: String,
      $rental_month: String,
      $po_number: String,
      $surrender_date: String,
      $vehicle_rc_book_attachments: [FileUploadInput],
      $insurance_policy_attachments: [FileUploadInput],
      $vehicle_lease_attachments: [FileUploadInput],
      $surrender_car_attachments: [FileUploadInput],
      $updated_date: String

    ) {
      ${AppConstants.update}${environment.dbPrefix}${AppConstants.createCpVehicleMaster}(input: {
        id: $id,
        car_model: $car_model,
        veh_reg_id: $veh_reg_id,
        policy_no: $policy_no,
        policy_from: $policy_from,
        policy_to: $policy_to,
        agency_name: $agency_name,
        lease_from: $lease_from,
        lease_to: $lease_to,
        car_type: $car_type,
        ex_data: $ex_data,
        car_make: $car_make,
        car_variant: $car_variant,
        car_color: $car_color,
        fuel_type: $fuel_type,
        car_registration_date: $car_registration_date,
        chasis_number: $chasis_number,
        map_user_id:$map_user_id,
        asset_number: $asset_number,
        surrender_date: $surrender_date,
        document_code: $document_code,
        rental_month: $rental_month,
        po_number: $po_number,
        surrender_date: $surrender_date,
        vehicle_rc_book_attachments: $vehicle_rc_book_attachments,
        insurance_policy_attachments: $insurance_policy_attachments,
        vehicle_lease_attachments: $vehicle_lease_attachments,
        surrender_car_attachments:$surrender_car_attachments,
        updated_date: $updated_date
      }) {

          id
          car_model
          veh_reg_id
          policy_no
          policy_from
          policy_to
          agency_name
          map_user_id
          lease_from
          lease_to
          car_type
          ex_data
          car_make
          car_variant
          car_color
          fuel_type
          car_registration_date
          chasis_number
          asset_number
          document_code
          rental_month
          po_number
          surrender_date
          created_date
          updated_date
          vehicle_rc_book_attachments
          {
            uploaded_on
            url
          }
          insurance_policy_attachments
          {
            uploaded_on
            url
          }
          vehicle_lease_attachments
           {
            uploaded_on
            url
          }
          surrender_car_attachments
          {
            uploaded_on
            url
          }
      }
    }
  `,
};

/*****************************************************************************
 * CP ASSIGNED CAR MAINTENANCE
 * $car_id: String,$status:String
 * ($limit: Int!,$nextToken:String)
 ****************************************************************************/
export const getCpAssignedCarQueries = {
  query: `
  query getCpAssignedCar ($nextToken: String, $limit: Int){
    ${AppConstants.list}${environment.dbPrefix}${AppConstants.listCpAssignedCar}(nextToken: $nextToken, limit: $limit)
    {
      items {
        id
        user_pid
        rn_id
        car_id
        assigned_date
        end_date
        status
        ex_data
        fuel_card_id
        car_return_date
        user {
          id
          user_name
          user_type
          name
        }
        car {
          id
          car_model
          veh_reg_id
          policy_no
          policy_from
          policy_to
          agency_name
          agency {
            id
            name
          }
          map_user_id
          lease_from
          lease_to
          car_type
          ex_data
          car_make
          car_variant
          car_color
          fuel_type
          car_registration_date
          chasis_number
          asset_number
          surrender_date
          created_date
          updated_date
          vehicle_rc_book_attachments
          {
            uploaded_on
            url
          }
          insurance_policy_attachments
          {
            uploaded_on
            url
          }
          vehicle_lease_attachments
          {
            uploaded_on
            url
          }
          surrender_car_attachments
          {
            uploaded_on
            url
          }
        }
        vehicle_return_attachments
          {
            uploaded_on
            url
          }
        vehicle_return_submission_date
      }
      nextToken
    }
  }
  `,
};

// car_return_date
// driver_allocation
export const filterByCpAssignedCarQueries = {

  query: `
  query ByUserType($nextToken: String, $limit: Int,$rn_id: String,$status:String){
    ${AppConstants.list}${environment.dbPrefix}${AppConstants.listCpAssignedCar} (nextToken: $nextToken, limit: $limit,filter:{
      rn_id : { eq : $rn_id}
      status : { eq : $status}
    })
    {
      items {
        id
        user_pid
        rn_id
        car_id
        assigned_date
        end_date
        status
        ex_data
      }
      nextToken
    }
  }
  `,


};
/*****************************************************************************
 * VEHICLE ASSIGNED TO USER
 * home_address
        office_address
 ****************************************************************************/
export const getDaVehicleMaster = {
  query: `
  query listcpVehicleMaintenance {
    ${AppConstants.list}${environment.dbPrefix}${AppConstants.listDaVehicleMasters} {

      items {
        id
        driver_id
        driver {
          user_name
          name
        }
        user_id
        user_name
        vehicle_model
        vehicle_no
        geofence_limit
        status
        created_at
        updated_at
        notification_flag
        user_phone_number
        agency_type
        driver_type
      }
      nextToken
    }
  }`,
};

/*****************************************************************************
 * VEHICLE MAINTENANCE
 ****************************************************************************/

export const listcpVehicleMaintenanceQueries = {
  query: `
  query listcpVehicleMaintenance {
    ${AppConstants.list}${environment.dbPrefix}${AppConstants.listCpCarMaintenance} {

      items {
          id
          username
          user_display_name
          veh_reg_no
          car_id
          request_status
          request_id
          user_request
          user_text
          comments{
            date
            des
            status
            exdata
          }
          req_date
          ex_data
          sla_date
          created_date
          updated_date
          feedback
          satisfaction
          odometer
      }
      nextToken
    }
  }`,
};

export const updatecpVehicleMaintenanceQueries = {
  mutation: `
  mutation updatecpVehicleMaintenance (
    $id: ID!,
    $comments: [HouseCommentsMapInput],
    $request_status: String,
    $updated_date:String,
    $ex_data: String,
    $sla_date: String
    ) {
    ${AppConstants.update}${environment.dbPrefix}${AppConstants.UpdateCpCarMaintenance}(input:{
      id: $id,
      comments: $comments,
      request_status: $request_status,
      updated_date: $updated_date,
      ex_data: $ex_data,
      sla_date: $sla_date
      }) {
          id
          username
          user_display_name
          veh_reg_no
          car_id
          request_status
          request_id
          user_request
          user_text
          comments{
            date
            des
            status
            exdata
          }
          req_date
          ex_data
          sla_date
          created_date
          updated_date
          feedback
          satisfaction
          odometer
      }


  }`,
};



export const updateassignedCarQueries = {
  mutation: `
    mutation updateCpAssignedCar(
      $id: ID!,
      $vehicle_return_attachments:[FileUploadInput],
      $car_return_date: String,
      $status: String,
      $vehicle_return_submission_date: String
    ) {
      ${AppConstants.update}${environment.dbPrefix}${AppConstants.updateCpAssignedCar}(input: {
        id: $id,
        vehicle_return_attachments:$vehicle_return_attachments,
        car_return_date: $car_return_date,
        status: $status,
        vehicle_return_submission_date: $vehicle_return_submission_date
      }) {
          id,
          car_return_date,
          status,
          vehicle_return_attachments
          {
            uploaded_on
            url
          }
          vehicle_return_submission_date
        }
      }`,
};

export const surrenderVehicleMasterQueries = {
  mutation: `
    mutation updateCpVehicleMaster(
      $id: ID!,
      $surrender_date: String,
      $surrender_car_attachments: [FileUploadInput],
      $updated_date: String
      $ex_data: String,
    ) {
      ${AppConstants.update}${environment.dbPrefix}${AppConstants.createCpVehicleMaster}(input: {
        id: $id,
        ex_data: $ex_data,
        surrender_date: $surrender_date,
        surrender_car_attachments:$surrender_car_attachments,
        updated_date: $updated_date
      }) {
          id
          ex_data
          surrender_date
          updated_date
          surrender_car_attachments
          {
            uploaded_on
            url
          }
      }
    }
  `,
};


export const updateVehicleMasterStatusQueries = {
  mutation: `
    mutation updateCpVehicleMaster(
      $id: ID!,
      $updated_date: String
      $ex_data: String,
    ) {
      ${AppConstants.update}${environment.dbPrefix}${AppConstants.createCpVehicleMaster}(input: {
        id: $id,
        updated_date: $updated_date,
        ex_data: $ex_data
      }) {
          id
          ex_data
          updated_date
      }
    }
  `,
};



export const getReturnAttachmentQueries = {
  query: `
  query getCpAssignedCar($car_id: String){
    ${AppConstants.list}${environment.dbPrefix}${AppConstants.listCpAssignedCar} (filter:{
      car_id : { eq : $car_id}
    })
    {
      items {
          id
          car_id
          car_return_date
          vehicle_return_attachments
          {
            uploaded_on
            url
          }
          vehicle_return_submission_date
          user_pid
          user {
             id
             name
             user_name
          }
      }
    }
  }
  `,
};